import React from 'react';
import { Button } from 'react-bootstrap';

// ─────────────────────────────────────────────────────────────
// DrawingLinks
//
// Renders the loading / error / empty / list states for the
// OneLine Drawings panel.
//
// Props:
//   drawings — array of drawing objects from the API
//   loading  — boolean fetch-in-progress flag
//   error    — error message string or null
//   onOpen   — (documentId: string, attestationId: string | null) => void
// ─────────────────────────────────────────────────────────────
const DrawingLinks = ({ drawings, loading, error, onOpen }) => {

  if (loading) {
    return (
      <div className="drawings-loading">
        <span>⏳</span>
        <span>Loading drawings…</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="drawings-error">
        ⚠️ {error}
      </div>
    );
  }

  if (!drawings.length) {
    return (
      <div className="drawings-empty">
        <span className="no-drawings-message">No Drawings Available</span>
      </div>
    );
  }

  return (
    <div className="drawings-list">
      {drawings.map((drawing) => (
        <div
          key={drawing.documentId ?? drawing.attachmentName}
          className="drawing-item"
        >
          <span className="drawing-filename">
            📄 {drawing.attachmentName}
          </span>

          {drawing.attestationId ? (
            <span className="drawing-attestation-id">
              Request #: <strong>{drawing.attestationId}</strong>
            </span>
          ) : (
            <span className="drawing-attestation-id drawing-attestation-id--empty" />
          )}

          <Button
            className="linkStyle drawing-action"
            onClick={() => onOpen(drawing.documentId, drawing.attestationId ?? null)}
            title="View assets in 3D viewer"
          >
            View in 3D Viewer
          </Button>
        </div>
      ))}
    </div>
  );
};

export default DrawingLinks;